import React from 'react';
import './Tenders.css';
import { useLanguage } from '../context/LanguageContext';

const Tenders = () => {
  const { t } = useLanguage();

  const tenders = [
    {
      id: 1,
      nameKey: 'tenders.tenderItems.bhaktaNiwas.name',
      descKey: 'tenders.tenderItems.bhaktaNiwas.description',
      costKey: 'tenders.tenderItems.bhaktaNiwas.estimatedCost',
      statusKey: 'tenders.tenderItems.bhaktaNiwas.status',
      deadlineKey: 'tenders.tenderItems.bhaktaNiwas.deadline'
    },
    {
      id: 2,
      nameKey: 'tenders.tenderItems.annaKshetra.name',
      descKey: 'tenders.tenderItems.annaKshetra.description',
      costKey: 'tenders.tenderItems.annaKshetra.estimatedCost',
      statusKey: 'tenders.tenderItems.annaKshetra.status',
      deadlineKey: 'tenders.tenderItems.annaKshetra.deadline'
    },
    {
      id: 3,
      nameKey: 'tenders.tenderItems.gardenDevelopment.name',
      descKey: 'tenders.tenderItems.gardenDevelopment.description',
      costKey: 'tenders.tenderItems.gardenDevelopment.estimatedCost',
      statusKey: 'tenders.tenderItems.gardenDevelopment.status',
      deadlineKey: 'tenders.tenderItems.gardenDevelopment.deadline'
    },
    {
      id: 4,
      nameKey: 'tenders.tenderItems.gauShala.name',
      descKey: 'tenders.tenderItems.gauShala.description',
      costKey: 'tenders.tenderItems.gauShala.estimatedCost',
      statusKey: 'tenders.tenderItems.gauShala.status',
      deadlineKey: 'tenders.tenderItems.gauShala.deadline'
    }
  ];

  return (
    <div className="tenders-page">
      <section className="tenders-hero">
        <div className="hero-overlay"></div>
        <div className="hero-content">
          <span className="hero-pill">{t('tenders.pageTitle')}</span>
          <h1>{t('tenders.pageSubtitle')}</h1>
          <div className="header-divider">
            <span className="dot"></span>
            <span className="line"></span>
            <span className="dot"></span>
          </div>
        </div>
      </section>

      <div className="container">
        <section className="tenders-section">
          <div className="tenders-intro">
            <p>
              {t('tenders.intro')}
            </p>
          </div>

          <div className="tenders-grid">
            {tenders.map(tender => {
              const statusValue = t(tender.statusKey).toLowerCase().replace(' ', '-');
              return (
                <div key={tender.id} className="tender-card">
                  <div className="tender-header">
                    <h3>{t(tender.nameKey)}</h3>
                    <span className={`status-badge ${statusValue}`}>
                      {t(tender.statusKey)}
                    </span>
                  </div>
                  
                  <p className="tender-description">{t(tender.descKey)}</p>
                  
                  <div className="tender-details">
                    <div className="detail-item">
                      <span className="detail-label">{t('tenders.estimatedCost')}</span>
                      <span className="detail-value">{t(tender.costKey)}</span>
                    </div>
                    <div className="detail-item">
                      <span className="detail-label">{t('tenders.deadline')}</span>
                      <span className="detail-value">{t(tender.deadlineKey)}</span>
                    </div>
                  </div>

                  <div className="tender-actions">
                    <button className="tender-btn download">
                      {t('tenders.downloadPDF')}
                    </button>
                    <button className="tender-btn inquiry">
                      {t('tenders.contactForInquiry')}
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="tender-contact-info">
            <h3>{t('tenders.tendersQueriesTitle')}</h3>
            <div className="contact-details">
              <p>{t('tenders.email')}</p>
              <p>{t('tenders.phone')}</p>
              <p>{t('tenders.officeHours')}</p>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
};

export default Tenders;
